import React from 'react';
import { SYSTEM_TYPES } from '../Library/libraryConstants';
import { iconTitles } from '../../Components/Tile/tileConstants';

interface TileChildProps {
    iconName?: string;
}

interface ManageResourceVisibilityContainerProps {
    canManageAphLoans: boolean;
    canManageLoans: boolean;
    canManageOrders: boolean;
    children: React.ReactNode;
    systemType: number;
}

export const ManageResourceVisibilityContainer: React.FC<ManageResourceVisibilityContainerProps> = ({
                                                      canManageAphLoans,
                                                      canManageLoans,
    canManageOrders,
    children,
    systemType
}) => {

    const isTextbooksSystem = systemType === SYSTEM_TYPES.Textbooks;


    const filteredChildren = React.Children.map(children, (child) => {

        if (React.isValidElement<TileChildProps>(child) && child.props?.iconName) {
            const iconName = child.props.iconName;

            switch (iconName) {
                case iconTitles.LOAN_MANAGEMENT:
                    return (canManageLoans || canManageAphLoans) ? child : null;

                case iconTitles.ORDER_MANAGEMENT:
                    return (isTextbooksSystem && canManageOrders) ? child : null;

                case iconTitles.CHECK_IN:
                    return (isTextbooksSystem && canManageLoans) ? child : null;

                default:
                    return child;
            }
        }

        return child;
    });


    return <>{filteredChildren}</>;
};
